import { AddonManager } from "../../scene/addon/AddonManager";
import { MaterialManager } from "../../material/MaterialManager";
import { Mesh } from "three";
import { Building } from "../Building";

/**
 * 4 vertical corner trims of the building where the walls meet.
 */
export class CornerTrim
{

	private _building : Building;

	private _left       : Mesh;
	private _right      : Mesh;
	private _left_back  : Mesh;
	private _right_back : Mesh;

	constructor(building:Building)
	{
		this._building = building;
		this.init();
	}

	private init = () =>
	{
		var addonManager = AddonManager.getInstance();
		var material = MaterialManager.getInstance().trim;

		this._left       = addonManager.createMesh("#0160 - RPN Outside Sculptured Corner", material) as Mesh;
		this._right      = addonManager.createMesh("#0160 - RPN Outside Sculptured Corner", material) as Mesh;
		this._left_back  = addonManager.createMesh("#0160 - RPN Outside Sculptured Corner", material) as Mesh;
		this._right_back = addonManager.createMesh("#0160 - RPN Outside Sculptured Corner", material) as Mesh;

		this._left_back.rotation.z  = Math.PI/2 * 2;
		this._left.rotation.z       = Math.PI/2 * 3;
		this._right.rotation.z      = Math.PI/2 * 0;
		this._right_back.rotation.z = Math.PI/2 * 1;

		this._right.castShadow = true;
		this._left.castShadow = true;
		this._right_back.castShadow = true;
		this._left_back.castShadow = true;

		this._building.scene3D.add(this._left);
		this._building.scene3D.add(this._right);
		this._building.scene3D.add(this._left_back);
		this._building.scene3D.add(this._right_back);

		this._building.config.building.propertyChange.add(this.update);
		this._building.config.building.single_slope.signal.add(this.update);
		this._building.config.building.pitch.signal.add(this.update);
		this.update();
	};

	private update = () =>
	{
		var metrics = this._building.config.metrics;

		var left_height  = metrics.height;
		var right_height = metrics.height;

		var single_slope = this._building.config.building.single_slope.value;
		//if (single_slope === "left")
		//{
		//	left_height += (metrics.width_half * metrics.tan) * 2;
		//} else
		if (single_slope)
		{
			right_height += (metrics.width_half * metrics.tan) * 2;
		}

		var left_height  = left_height  * AddonManager.DEFAULT_SCALE - 0.3;
		var right_height = right_height * AddonManager.DEFAULT_SCALE - 0.3;


		this._left.position.x = -metrics.width_half;
		this._left.position.y = 0;
		this._left.position.z = metrics.length_half;
		this._left.scale.z = left_height;

		this._left_back.position.x = -metrics.width_half;
		this._left_back.position.y = 0;
		this._left_back.position.z = -metrics.length_half;
		this._left_back.scale.z = left_height;

		this._right.position.x = metrics.width_half;
		this._right.position.y = 0;
		this._right.position.z = metrics.length_half;
		this._right.scale.z = right_height;

		this._right_back.position.x = metrics.width_half;
		this._right_back.position.y = 0;
		this._right_back.position.z = -metrics.length_half;
		this._right_back.scale.z = right_height;
	}
}